import Base from "./comn";

const App = () => {
    return <Base />;
};

export default App;
